// extracted by mini-css-extract-plugin
module.exports = {"vanlife-L-power":"Power_vanlife-L-power__ZG6wu"};